export default __webpack_public_path__ + "static/media/Blade of the Fallen King.05700d4b.jpg";